<template>
    <div class="homeindex">
        <vue-particles
            color="#2D5576"
            :particleOpacity="0.7"
            :particlesNumber="60"
            shapeType="circle"
            :particleSize="4"
            linesColor="#69769D"
            :linesWidth="1"
            :lineLinked="true"
            :lineOpacity="0.4"
            :linesDistance="150"
            :moveSpeed="2"
            :hoverEffect="true"
            hoverMode="grab"
            :clickEffect="true"
            clickMode="push"
            class="login1"
        >
        </vue-particles>

        <div class="login-title1">
            <div class="login-title-box1">
                <span style="margin-top: 20px"> 智慧养老e+综合服务平台</span>
            </div>
        </div>
        <div class="content-box1">
            <el-carousel
                :interval="4000"
                type="card"
                height="284px"
                :autoplay="false"
                ref="carousel"
                @change="carouselChange"
                arrow="always"
                :initial-index="initialIndex"
            >
                <el-carousel-item
                    v-for="item in listData"
                    :key="item.value"
                    :data-id="item.id"
                    :data-aa="item.title"
                >
                    <div class="el-carousel-everybox">
                        <div class="el-carousel-everybox-bgimg"></div>
                        <div class="outbox">
                            <div class="every-inner every-innerimg">
                                <img
                                    :src="item.imgPath"
                                    alt=""
                                    style="
                                        margin-bottom: 20px;
                                        width: 85px;
                                        height: auto;
                                    "
                                    class="every-innerimg1"
                                />
                            </div>
                            <div
                                class="every-inner every-innertext"
                                style="
                                    position: absolute;
                                    top: 193px;
                                    font-size: 14px;
                                "
                            >
                                <span style="color: #fff">{{ item.name }}</span>
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="nav_menu">
            <ul class="menu_separate" v-if="carouseId == '社区养老'">
                <i class="idian dian1"></i>
                <i class="idian dian2"></i>
                <i class="idian dian3"></i>
                <i class="idian dian4"></i>
                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('就餐信息')"
                        @click="gopage('orderFoodIndex')"
                        class="menu_separate_li"
                    >
                        就餐信息
                    </p>
                </li>

                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('时间银行')"
                        @click="gopage('timeBank')"
                        class="menu_separate_li"
                    >
                        时间银行
                    </p>
                </li>
                <li class="menu_separate_liss">
                    <p
                        class="menu_separate_li"
                        v-if="isShowMenu('五社联动')"
                        @click="gopage('fiveLinkage')"
                    >
                        五社联动
                    </p>
                </li>

                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('家庭床位管理系统')"
                        @click="gopage('bedPage')"
                        class="menu_separate_li"
                    >
                        家庭养老床位
                    </p>
                </li>
                <!-- <li class="menu_separate_lis"></li> -->
                <li style="margin-let: 200px" class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('就餐信息')"
                        @click="gopage('mealAid')"
                        class="menu_separate_li timeBank"
                    >
                        可视化
                    </p>
                </li>
                <li style="margin-let: 200px" class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('时间银行')"
                        @click="gopage('date')"
                        class="menu_separate_li timeBank"
                    >
                        可视化
                    </p>
                </li>
                <li class="menu_separate_liss"></li>
                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('家庭床位管理系统')"
                        @click="gopage('bedManage')"
                        class="menu_separate_li timeBank"
                    >
                        可视化
                    </p>
                </li>
            </ul>
            <ul class="menu_separate" v-if="carouseId == '客服系统'">
                <i class="idian dian1"></i
                ><i class="idian dian2"></i
                ><i class="idian dian3"></i
                ><i class="idian dian4"></i>
                <li class="menu_separate_li">客服中心</li>
                <li class="menu_separate_li">工单系统</li>
                <li class="menu_separate_li">可视化</li>
            </ul>
            <ul class="menu_separate" v-if="carouseId == '机构养老系统'">
                <i class="idian dian1"></i
                ><i class="idian dian2"></i
                ><i class="idian dian3"></i
                ><i class="idian dian4"></i>
                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('机构养老')"
                        @click="gopage('olderInstitution')"
                        class="menu_separate_li"
                    >
                        机构养老
                    </p>
                </li>
                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('民政监管')"
                        @click="gopage('civilAdministrationSupervision')"
                        class="menu_separate_li"
                    >
                        民政监管
                    </p>
                </li>
                <li class="menu_separate_liss"></li>
                <li class="menu_separate_liss"></li>
                <!-- <li
                    class="menu_separate_liss"
                    v-if="!isShowMenu('民政监管')"
                ></li>
                <li
                    class="menu_separate_liss"
                    v-if="!isShowMenu('机构养老')"
                ></li> -->
                <!-- <li class="menu_separate_liss"></li>
                <li class="menu_separate_liss"></li> -->
                <!-- <li class="menu_separate_liss"></li>
                <li class="menu_separate_liss"></li> -->
                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('机构养老一张图')"
                        @click="gopage('oldManStatistics')"
                        class="menu_separate_li"
                    >
                        机构养老一张图
                    </p>
                </li>
                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('监管可视化平台')"
                        @click="gopage('supVisit')"
                        class="menu_separate_li"
                    >
                        监管可视化平台
                    </p>
                </li>
            </ul>
            <ul class="menu_separate" v-if="carouseId == '社区养老系统'">
                <i class="idian dian1"></i
                ><i class="idian dian2"></i
                ><i class="idian dian3"></i
                ><i class="idian dian4"></i>
                <li class="menu_separate_li">日照中心</li>
                <!-- <li class="menu_separate_li">家庭床位</li> -->
                <li class="menu_separate_li">疫情防控</li>
            </ul>
            <ul class="menu_separate" v-if="carouseId == '智慧养老云平台'">
                <i class="idian dian1"></i
                ><i class="idian dian2"></i
                ><i class="idian dian3"></i
                ><i class="idian dian4"></i>
                <li
                    class="menu_separate_li"
                    @click="gopage('regulatoryPlatform')"
                    v-if="isShowMenu('监管平台')"
                >
                    监管平台
                </li>
                <li
                    @click="gopage('elderlyService')"
                    class="menu_separate_li"
                    v-if="isShowMenu('养老服务')"
                >
                    养老服务
                </li>
                <li
                    @click="gopage('trainSystem')"
                    class="menu_separate_li"
                    v-if="isShowMenu('人才培训系统')"
                >
                    人才培训系统
                </li>
                <li
                    @click="gopage('system')"
                    class="menu_separate_li"
                    v-if="isShowMenu('系统设置')"
                >
                    系统设置
                </li>

                <!-- <li
                    class="menu_separate_liss"
                    v-if="!isShowMenu('智能监控')"
                ></li> -->
                <li
                    @click="gopage('znjk')"
                    class="menu_separate_li"
                    v-if="isShowMenu('智能监控')"
                >
                    智能监控
                </li>
                <!-- <li
                    class="menu_separate_liss"
                    v-if="!isShowMenu('街道一张图')"
                ></li> -->
                <li
                    @click="gopage('streetMap')"
                    class="menu_separate_li"
                    v-if="isShowMenu('街道一张图')"
                >
                    街道一张图
                </li>
                <!-- <li
                    class="menu_separate_liss"
                    v-if="!isShowMenu('绩溪养老大数据')"
                ></li> -->
                <!-- <li
                    @click="gopage('hgVisit')"
                    class="menu_separate_li"
                    v-if="isShowMenu('黄冈养老大数据')"
                >
                    黄冈养老大数据
                </li> -->
                <li
                    @click="gopage('hgVisit')"
                    class="menu_separate_li"
                    v-if="isShowMenu('绩溪养老大数据')"
                >
                    绩溪养老大数据
                </li>
                <li
                    @click="gopage('laVisit')"
                    class="menu_separate_li"
                    v-if="isShowMenu('来安养老大数据')"
                >
                    来安养老大数据
                </li>
            </ul>
            <ul class="menu_separate" v-if="carouseId == '居家服务'">
                <i class="idian dian1"></i
                ><i class="idian dian2"></i
                ><i class="idian dian3"></i
                ><i class="idian dian4"></i>
                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('客服中心')"
                        @click="gopage('callCenter')"
                        class="menu_separate_li"
                    >
                        客服中心
                    </p>
                </li>
                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('适老化管理')"
                        @click="gopage('elderManage')"
                        class="menu_separate_li"
                    >
                        适老化管理
                    </p>
                </li>
                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('走访探视')"
                        @click="gopage('oldAdministration')"
                        class="menu_separate_li"
                    >
                        走访探视
                    </p>
                </li>
                <li class="menu_separate_liss"></li>
                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('客服中心')"
                        @click="gopage('oldBigData')"
                        class="menu_separate_li"
                    >
                        可视化
                    </p>
                </li>
                <!-- <li class="menu_separate_liss">
                    <p
                        class="menu_separate_li"
                        @click="gopage('bigDataPlatform')"
                    >
                        可视化
                    </p>
                </li> -->
                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('适老化管理')"
                        @click="gopage('olderman')"
                        class="menu_separate_li"
                    >
                        可视化
                    </p>
                </li>
                <li class="menu_separate_liss">
                    <p
                        v-if="isShowMenu('走访探视')"
                        @click="gopage('visit')"
                        class="menu_separate_li"
                    >
                        可视化
                    </p>
                </li>
            </ul>
            <ul class="menu_separate" v-if="carouseId == '智慧党建'">
                <i class="idian dian1"></i
                ><i class="idian dian2"></i
                ><i class="idian dian3"></i
                ><i class="idian dian4"></i>
                <li
                    class="menu_separate_li"
                    @click="gopage('partybuildSystem')"
                    v-if="isShowMenu('党建管理系统')"
                >
                    党建管理系统
                </li>
                <li
                    @click="gopage('dataCenterindex')"
                    class="menu_separate_li"
                    v-if="isShowMenu('党建可视化')"
                >
                    党建可视化
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            userName: null,
            password: null,
            rememberPassword: false,
            loading: false,
            testcode: null,
            carouseId: "1",
            initialIndex: 0,
            listDataPhoto: {
                社区养老: require("../assets/image112/shequyanglao.png"),
                客服系统: require("../assets/image112/kefuxitong.png"),
                机构养老系统: require("../assets/image112/jigouyanglao.png"),
                社区养老系统: require("../assets/image112/shequyanglao.png"),
                智慧养老云平台: require("../assets/image112/yunpingtai.png"),
                居家服务: require("../assets/image112/jujiafuwu.png"),
                智慧党建: require("../assets/image112/dangjian.png"),
            },
            listData: [
                {
                    name: "社区养老",
                    imgPath: require("../assets/image112/a1.png"),
                    value: "1",
                },
                {
                    name: "客服系统",
                    imgPath: require("../assets/image112/a2.png"),
                    value: "2",
                },
                {
                    name: "机构养老系统",
                    imgPath: require("../assets/image112/a5.png"),
                    value: "3",
                },
                {
                    name: "社区养老系统",
                    imgPath: require("../assets/image112/a6.png"),
                    value: "4",
                },
                {
                    name: "智慧养老云平台",
                    imgPath: require("../assets/image112/a7.png"),
                    value: "5",
                },
                {
                    name: "居家服务",
                    imgPath: require("../assets/image112/a9.png"),
                    value: "6",
                },
            ],
            currentMenu: [],
        }
    },
    created() {
        let tempDate = this.$store.state.menu.map((item) => {
            return {
                name: item.title,
                id: item.id,
                children: item.children,
                imgPath: this.listDataPhoto[item.title]
                    ? this.listDataPhoto[item.title]
                    : require("../assets/image112/a2.png"),
            }
        })
        this.listData = tempDate
        if (tempDate.length == 0) {
            this.$message.info("暂无权限，请联系管理员")
            return
        }
        let initialIndex = window.sessionStorage.getItem("initialIndex")
        let carouseId = window.sessionStorage.getItem("carouseId")
        let tempArr = []
        if (
            initialIndex === null ||
            initialIndex === undefined ||
            initialIndex === ""
        ) {
            this.initialIndex = 0
            this.carouseId = tempDate[0].name
            tempDate[0].children.forEach((item) => {
                tempArr.push(item.title)
            })
        } else {
            this.initialIndex = Number(initialIndex)
            this.carouseId = carouseId
            let { children = [] } = tempDate.find(
                (item) => item.name == carouseId
            )
            children.forEach((item) => {
                tempArr.push(item.title)
            })
        }
        this.currentMenu = tempArr
    },
    methods: {
        addClass() {
            try {
                this.$nextTick(() => {
                    let el = document.querySelectorAll(".menu_separate_li")
                    for (let i = 0; i < el.length; i++) {
                        el[i].onmouseenter = () => {
                            let parentNode = el[i].parentElement.children
                            for (let a = 0; a < parentNode.length; a++) {
                                if (
                                    parentNode[a].className.includes(
                                        "dian" + ((i % 4) + 1)
                                    )
                                ) {
                                    parentNode[a].classList.add("dian_active")
                                }
                            }
                        }
                        el[i].onmouseout = () => {
                            let parentNode = el[i].parentElement.children
                            for (let a = 0; a < parentNode.length; a++) {
                                if (
                                    parentNode[a].className.includes(
                                        "dian" + ((i % 4) + 1)
                                    )
                                ) {
                                    parentNode[a].classList.remove(
                                        "dian_active"
                                    )
                                }
                            }
                        }
                    }
                })
            } catch (error) {
                console.log(error)
            }
        },
        gopage(pageName) {
            this.$router.push({ name: pageName })
        },
        carouselChange(now) {
            let menuList = this.$store.state.menu
            this.$nextTick(() => {
                let el = document.querySelector(".el-carousel__item.is-active")
                let id = el.dataset.id
                let temp = menuList.find((item) => item.id == id)
                let tempArr = []
                this.carouseId = temp.title
                window.sessionStorage.setItem("initialIndex", now)
                window.sessionStorage.setItem("carouseId", temp.title)
                let { children = [] } = menuList.find(
                    (item) => item.title == temp.title
                )
                children.forEach((item) => {
                    tempArr.push(item.title)
                })
                this.currentMenu = tempArr
            })
            setTimeout(() => {
                this.addClass()
            }, 100)
        },
        isShowMenu(name) {
            return this.currentMenu.includes(name)
        },
    },
    mounted() {
        this.addClass()
    },
}
</script>

<style lang="less">
@keyframes pictureSwitch {
    0%,
    100% {
        background: url("../assets/image112/carousel_1.png") no-repeat center
            center;
        background-size: 100% 94%;
    }
    50% {
        background: url("../assets/image112/carousel_2.png") no-repeat center
            center;
        background-size: 100% 94%;
    }
}
body,
html {
    width: 100%;
    min-height: 100%;
    background: url(../assets/image112/bgimg.jpg) no-repeat;
    // overflow: hidden;
    background-size: 100% 100%;
}
.homeindex {
    /deep/ .el-carousel__item.is-active {
        .el-carousel-everybox-bgimg {
            background: url("../assets/image112/box_border_active.png")
                no-repeat center center;
            background-size: 100% 94%;
        }
    }
    .login1 {
        position: absolute;
        width: 100%;
        height: 100vh;
        background: url(../assets/image112/bgimg.jpg);
        overflow: hidden;
        background-size: 100% 100%;
        color: #02d4de;
    }
    .login-title1 {
        position: absolute;
        top: 50px;
        z-index: 1000;
        color: #fff;
        /* font-family: "FangSong"; */
        font-size: 50px;
        font-weight: bold;
        width: 100%;
    }
    .login-title-box1 {
        text-align: center;
    }
    .content-box1 {
        position: absolute;
        z-index: 1000;
        left: 50%;
        top: 40%;
        width: 80%;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        background: rgba(255, 255, 255, 0);
    }

    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
    }

    .el-carousel-everybox {
        display: flex;
        justify-content: center;
        margin-top: 80px;
    }
    .el-carousel-everybox-bgimg {
        position: absolute;
        top: -11px;
        z-index: -1;
        width: 270px;
        height: 250px;
        background: url("../assets/image112/carousel_1.png") no-repeat center
            center;
        background-size: 100% 94%;
    }
    .el-carousel-everybox-bgimg img {
        width: 200px;
        height: 180px;
        margin-top: 50px;
    }
    .el-carousel__mask {
        background-color: rgba(255, 255, 255, 0);
    }
    .el-carousel__item.is-active .everybgimg {
        width: 270px;
        height: 250px;
        margin-top: 17px;
        content: url(../assets/image112/box_border_active.png);
    }
    .el-carousel__item.is-active .every-innerimg1 {
        height: 80px;
        margin-top: -10px;
    }
    .outbox {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .outbox .fen-ge {
        width: 100%;
        height: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .outbox .fen-ge span {
        width: 28;
        height: 4px;
        background-color: #91ee21;
    }
    .el-carousel__item.is-active .every-innertext {
        font-size: 13px;
    }

    .el-icon-arrow-left {
        content: url(../assets/image112/arrow_left.png);
        width: 20px;
        height: 25px;
    }
    .el-icon-arrow-right {
        content: url(../assets/image112/arrow_right.png);
        width: 20px;
        height: 25px;
    }
    .el-carousel__indicators--outside {
        display: none;
    }
    .nav_menu {
        padding-bottom: 50px;
        position: absolute;
        top: 67%;
        left: 50%;
        transform: translateX(-50%);
        width: 850px;
        margin: 0 auto;
    }
    .nav_menu .menu_separate {
        padding: 0 25px;
        padding-top: 40px;
        border-top: 2px solid #304e7d;
        position: relative;
    }
    .menu_separate .idian {
        position: absolute;
        background-image: url(../assets/image112/icon_sidian.png);
        background-size: 100% 100%;
        height: 50px;
        width: 50px;
        top: -29px;
    }
    .dian1 {
        left: 95px;
    }
    .dian2 {
        left: 292px;
    }
    .dian3 {
        left: 490px;
    }
    .dian4 {
        left: 695px;
    }
    .dian_active {
        background-image: url(../assets/image112/icon_sidian_green.png) !important;
        background-size: 100% 100%;
    }
    .menu_separate_lis {
        float: left;
        width: 180px;
        height: 40px;
        line-height: 40px;
        margin-right: 20px;
        margin-top: 20px;
    }
    .menu_separate_liss {
        float: left;
        width: 180px;
        height: 40px;
        line-height: 40px;
        margin-right: 20px;
        margin-top: 20px;
    }

    .menu_separate_li {
        float: left;
        background-image: url(../assets/image112/fontOrone__55.png);
        background-size: 100% 100%;
        /* content: url(../assets/image112/fontOrone__55.png);  */
        width: 180px;
        height: 40px;
        color: #fff;
        text-align: center;
        line-height: 40px;
        margin-right: 20px;
        margin-top: 20px;
        cursor: pointer;
        &:hover {
            background-image: url(../assets/image112/fontOrone__52.png);
        }
    }
    p.menu_separate_li {
        margin-top: 0;
    }
    .picnone {
        background-image: none;
        cursor: default;
        &:hover {
            background-image: none;
        }
    }
}
</style>
